/**
 * Bridges Sharetribe session → Firebase Auth via custom tokens from our Express API.
 * Firestore rules use request.auth.uid which must match Sharetribe user UUID.
 */

import {
  getFirebaseAuth,
  signInWithCustomToken,
  signOut,
  onAuthStateChanged,
} from '../../firebase/app';
import { fetchFirebaseCustomToken } from '../../util/api';

let signInPromise = null;

/**
 * Sign in to Firebase when Sharetribe user is authenticated.
 * Deduplicates concurrent calls during app init.
 * @param {string} sharetribeUserId currentUser.id.uuid
 */
export const ensureFirebaseAuthForUser = async sharetribeUserId => {
  if (!sharetribeUserId) {
    return null;
  }

  const auth = getFirebaseAuth();
  if (!auth) {
    return null;
  }

  if (auth.currentUser?.uid === sharetribeUserId) {
    return auth.currentUser;
  }

  if (signInPromise) {
    return signInPromise;
  }

  signInPromise = (async () => {
    try {
      const { token } = await fetchFirebaseCustomToken();
      const credential = await signInWithCustomToken(auth, token);
      if (credential.user.uid !== sharetribeUserId) {
        console.warn(
          '[Wishlist] Firebase uid mismatch:',
          credential.user.uid,
          sharetribeUserId
        );
      }
      return credential.user;
    } finally {
      signInPromise = null;
    }
  })();

  return signInPromise;
};

export const signOutFirebase = () => {
  const auth = getFirebaseAuth();
  if (!auth) {
    return Promise.resolve();
  }
  return signOut(auth);
};

export { onAuthStateChanged };
